import { Routes } from '@angular/router';
import { AppUrls } from './app-urls';
import { SignInPage } from '../signin/sign-in.page';
import { ShellLayout } from '../shell/shell.layout';
import { authGuard } from '../core/authentication/auth.guard';
import { NoAccessPage } from '../no-access/no-access.page';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: AppUrls.signInUrl,
    },
    {
        path: AppUrls.signInUrl,
        component: SignInPage,
    },
    {
        path: AppUrls.noAccessUrl,
        component: NoAccessPage,
        canActivate: [authGuard],
    },
    {
        path: '',
        component: ShellLayout,
        canActivate: [authGuard],
        children: [
            // {
            //     path: AppUrls.homeUrl,
            //     loadComponent: () =>
            //         import('../home/home.page').then(m => m.HomePage),
            // },
            {
                path: AppUrls.dataDropUrl,
                loadComponent: () =>
                    import('../data-drop/data-drop.page').then(m => m.DataDropPage),
            },
            {
                path: AppUrls.hotelGptUrl,
                loadComponent: () =>
                    import('../hotel-gpt/hotel-gpt.page').then(m => m.HotelGptPage),
            },
        ],
    },
    {
        path: '**',
        redirectTo: AppUrls.signInUrl,
    },
];
